import React from 'react';
import {Point} from '../../../../data/models/LessonContent/ContentFreeform';
import {BASELINE_SVG_CANVAS_WIDTH} from '../SvgCanvas';

interface Props {
  points: {[key: number]: Point};
  setPoints: (points: {[key: number]: Point}) => void;
  onDragFinished: () => void;
  width: number;
}

const PathSvgHandles = React.memo(
  ({points, setPoints, onDragFinished, width}: Props) => {
    const [handlePosition, setHandlePosition] = React.useState({
      active: false,
      handleId: -1,
      offset: {x: 0, y: 0},
    });

    const getScaleFactor = () => {
      const scale = (width * 100) / BASELINE_SVG_CANVAS_WIDTH;
      return scale / 100;
    };

    const handleHandlesPointerDown = (handleId: number) => (e: any) => {
      const el = e.target;
      const bbox = e.target.getBoundingClientRect();
      const x = e.clientX - bbox.left;
      const y = e.clientY - bbox.top;
      el.setPointerCapture(e.pointerId);
      setHandlePosition({
        ...handlePosition,
        active: true,
        handleId: handleId,
        offset: {
          x,
          y,
        },
      });
    };

    const handleHandlesPointerMove = (e: any) => {
      const bbox = e.target.getBoundingClientRect();
      const x = e.clientX - bbox.left;
      const y = e.clientY - bbox.top;
      if (handlePosition.active && handlePosition.handleId !== -1) {
        const newPoints = {
          ...points,
          [handlePosition.handleId]: {
            x:
              points[handlePosition.handleId].x -
              (handlePosition.offset.x - x) / getScaleFactor(),
            y:
              points[handlePosition.handleId].y -
              (handlePosition.offset.y - y) / getScaleFactor(),
          },
        };
        setPoints(newPoints);
      }
    };

    const handleHandlesPointerUp = () => {
      setHandlePosition({
        ...handlePosition,
        active: false,
        handleId: -1,
      });
      onDragFinished();
    };

    return (
      <g>
        {Object.keys(points).map((handle: string) => (
          <circle
            cx={points[parseInt(handle, 10)].x}
            cy={points[parseInt(handle, 10)].y}
            r={4}
            fill="white"
            stroke="#53B483"
            strokeWidth={2}
            onPointerDown={handleHandlesPointerDown(parseInt(handle, 10))}
            onPointerMove={handleHandlesPointerMove}
            onPointerUp={handleHandlesPointerUp}
            key={handle}
            cursor={'move'}
          />
        ))}
      </g>
    );
  },
);

export default PathSvgHandles;
